// Links between the same page for each game: How to play, Characters. Links, not buttons: these
// pages are outside a room, so changing the address is fine.
import { Link } from "react-router-dom";

export const GAMES: { id: string; name: string }[] = [
  { id: "trouble_brewing", name: "Trouble Brewing" },
  { id: "bad_moon_rising", name: "Bad Moon Rising" },
];

export function GameSwitch({ current, path }: { current: string; path: (id: string) => string }) {
  return (
    <nav className="toc" aria-label="Game">
      {GAMES.map((g) =>
        g.id === current ? (
          <span key={g.id} className="chip chip-accent" aria-current="page">
            {g.name}
          </span>
        ) : (
          <Link key={g.id} className="chip" to={path(g.id)}>
            {g.name}
          </Link>
        ),
      )}
    </nav>
  );
}
